import { theme as oldTheme } from '@ublend-npm/aulaui-next';
import { styled } from '@ublend-npm/aulaui-core';
import { MessageMenuContainer } from './MessageMenu.styled';

const getMessageColor = ({ pending, failed }) => {
  if (failed) {
    return oldTheme.color.red;
  }
  if (pending) {
    return oldTheme.color.grayDark;
  }
  return 'inherit';
};
const getMessageOpacity = ({ pending, failed }) =>
  pending || failed ? '0.56' : '1';

export const MessageContainer = styled('div')`
  flex-grow: 1;
  opacity: ${(props) => getMessageOpacity(props)};
  color: ${(props) => getMessageColor(props)};
  font-size: 14px;
  line-height: 1.5;
  color: #1a1a1a;
  margin-bottom: 4px;
  word-wrap: break-word;
  .RichEditor-editor {
    margin-bottom: 0 !important;
  }
`;

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  borderRadius: '6px',
  marginBottom: '1.5rem',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    [MessageMenuContainer]: {
      opacity: 1,
    },
  },
}));
//   display: flex;
//   flex-direction: row;
//   position: relative;
//   background-color: ${({ highlighted }) =>
//     highlighted ? '#f0f8ff' : 'transparent'};
//   transition: background-color 0.3s;
//   &:hover {
//     background-color: ${theme.color.grayLight};
//     transition: background-color 0s;
//     ${MessageMenuContainer} {
//       opacity: 1;
//     }
//   }
// `;
